import script from "./AiChatBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiChatBanner.vue?vue&type=script&setup=true&lang=ts"

import "./AiChatBanner.vue?vue&type=style&index=0&id=2c125041&lang=css"
import "./AiChatBanner.vue?vue&type=style&index=1&id=2c125041&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c125041"]])

export default __exports__